<template>
	<v-container fluid id="profil-page-settings">
		<v-row>
			<v-col cols="12" class="text size-xlarge weight-bold font-alt">
				Mettez à jour vos informations
			</v-col>
		</v-row>
		<v-row class="px-3 mt-8">
			<v-col cols="12" class="colored-bg mb-5">
                <v-row class="pa-3 mb-1">
                    <v-col
                        md="12"
                        lg="7"
                    >
                        <div class="pb-8 text-center text size-large font-weight-bold">Information personnelle</div>
                        	<v-card class="theme-card rounded pt-5">
								<v-row
                                    align="center" 
                                    class="pl-5 pt-0 pb-5 d-flex flex-row"
                                >
                                    <v-col 
                                        lg="2"
                                        md="12"
                                    >
                                        <v-avatar
                                            class="avatar"
                                            height= 106
                                            width= 91
                                        >
                                            <img
                                                :src="profilImg"
                                                alt="John"
                                            >
                                        </v-avatar>
                                    </v-col>
                                    <v-col
                                        lg="10"
                                        md="12"
                                    >
                                        <div class="clientRef text size-xsmall font-weight-bold">Numéro Client {{ clientNb }}</div>
                                        <div class="text size-xsmall font-weight-bold">Mettre à jour votre photo</div>
                                        <div class="downloadImg text size-small ">Chargez une image ou importez-là depuis <strong>instagram</strong> ou <strong>Facebook</strong></div>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-col class="px-5">
                                    <v-row class="pt-5">
                                        <TextInput
                                            outlined 
                                            v-model="userData.firstname"
                                            :placeholder= "userData.firstname" 
                                            label="Nom"
                                        />
                                        <TextInput
                                            outlined 
                                            v-model="userData.lastname"
                                            :placeholder= "userData.lastname" 
                                            label="Prénom"
                                        />
                                        <TextInput
                                            outlined 
                                            v-model="userData.function"
                                            :placeholder="userData.function"
                                            label="Fonction"
                                        />
                                    </v-row>
                                     <v-row class="">
                                        <TextInput
                                            outlined 
                                            v-model="userData.email"
                                            :placeholder="userData.email"
                                            label="Adresse email"
                                        />
                                        <TextInput
                                            outlined 
                                            v-model="userData.phone_number"
                                            :placeholder="userData.phone_number"
                                            label="Téléphone"
                                        />
                                    </v-row>
                                     <v-row class="">
                                         <TextInput
                                            outlined 
                                            v-model="social"
                                            placeholder="Raison sociale"
                                            label="Raison sociale"
                                        />
                                        <TextInput
                                            outlined 
                                            v-model="userData.address"
                                            :placeholder="userData.address"
                                            label="Adresse de facturation"
                                        />
                                    </v-row>
                                     <v-row class="pb-3">
                                         <TextInput
                                            outlined 
                                            v-model="userData.city"
                                            :placeholder="userData.city"
                                            label="Ville"
                                        />
                                        <TextInput
                                            outlined 
                                            v-model="userData.postal_code"
                                            :placeholder="userData.postal_code"
                                            label="Code postal"
                                        />
                                        <TextInput
                                            outlined 
                                            v-model="addressInfo"
                                            placeholder="Complément"
                                            label="Complément d'adresse"
                                        />
                                    </v-row>
                                </v-col>
                                <v-divider></v-divider>
                                <v-row class="pt-5 px-5 pb-6">
                                    <TextInput 
                                        outlined
                                        v-model="userData.fb_link"
                                        :placeholder="userData.fb_link"
                                        label="Facebook"
                                    />
                                    <v-col col="6">
                                        <v-btn
                                            x-large
                                            class="$purple-alt theme-btn with-dashed"
                                            elevation="0"
                                        >
                                        <p class="addLink $purple-alt"> + Ajouter un autre lien </p>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-5 px-5 pb-4">
                                    <TextInput 
                                        outlined
                                        v-model="paymentType"
                                        placeholder="Paiement par carte bleue"
                                        label="Moyen de paiement"
                                        icon="check_circle_outline"
                                    />
                                    <v-col
                                        class="pt-11" 
                                        col="6"
                                    >
                                        <v-btn
                                            x-large
                                            class="majBtn"
                                            elevation="0"
                                            @click="updateManager()"
                                        >
                                            <p class="color-white"> METTRE À JOUR </p>
                                        </v-btn>
                                    </v-col>
                                </v-row>
							</v-card>
                    </v-col>
                    <v-col 
                        lg="5"
                        md="12"
                    >
                        <div class="pb-8 text-center text size-large font-weight-bold">Historique de facturation</div>
                        <v-card class="theme-card rounded pt-1 pb-7">
							<v-col cols="12">
                                <div id="search-zone" class="px-3 py-3">
                                    <v-text-field
                                        v-model="searchFilter"
                                        class="mx-0"
                                        solo
                                        label="Rechercher une facture"
                                        hide-details
                                        prepend-inner-icon="search"
                                    ></v-text-field>
                                </div>
                                <InvoiceTable />
                            </v-col>
						</v-card>
                    </v-col>
                </v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script type="text/javascript">
  import TextInput from '@/components/input/textInput'
  import InvoiceTable from './invoiceTable.vue'
  import profil from '../../../../data/profil.json'


  export default {
    components: {
      TextInput,
      InvoiceTable,
    },
    props: {
      placeholder: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
    },
    data() {
        return {
            firstname: null ,
            lastname: null,
            function: null,
            mail: null,
            phone_number: null,
            social : null,
            addressInfo : null,
            address: null,
            city: null,
            postal_code: null,
            fb_link: null,
            paymentType: null,
            headers : null,
        }
    },
    created() {
        this.social = "",
        this.addressInfo = "",
        this.paymentType= "";
        this.headers = profil.settings.personalInfoHeaders;
    },
    methods : {
        updateManager() {
            const params = {
                'firstname' : this.firstname,
                'lastname' : this.lastname,
                'function' : this.function,
                'mail' : this.mail,
                'phone_number' : this.phone_number,
                'address' : this.address,
                'city' : this.city,
                'postal_code' : this.postal_code,
                'fb_link' : this.fb_link,
                'managerId' : this.managerId
            };
            this.$store.dispatch('auth/updateManager', params);
        }
    },
  
    computed: {
        clientNb() {
            return  this.$store.state.profil.settings.userInfos.clientNb;
        },
        profilImg() {
            return  this.$store.state.profil.settings.userInfos.profilImg;
        },
        userData() {
            let manager = this.$store.state.auth.users.data;
                this.firstname= manager.firstname ;
                this.lastname= manager.lastname ;
                this.function= manager.function;
                this.mail= manager.email;
                this.phone_number= manager.phone_number;
                this.address= manager.address;
                this.city = manager.city,
                this.postal_code = manager.postal_code;
                this.fb_link = manager.fb_link;
            return this.$store.state.auth.users.data;
        },
        managerId() {
            return this.$store.state.auth.users.data.user_id;
        },
        searchFilter : {
            get () {
                // return this.$store.state.userOverview.databaseFilters.search;
            },
            set (value) {
                // this.$store.commit('userOverview/setDbFilterSearch', value);
            }
        }
    },
 
  }
</script>

<style lang="scss">
	#profil-page-settings {
		.avatar {
            border-radius: 35px;
        }
        .clientRef {
            color: $purple-alt;
        }
        .downloadImg {
            margin-top: -5px !important;
        }
        .addLink {
            margin-bottom: 0px !important;
            color: $purple-alt;
        }
        .addLinkBtn {
            margin-top: 33px;
            height: 55px;
            width: 100%;
            background-color: #f9fafe;
            border-style: dashed ;
            border-color: $purple-alt;
        }
        .majBtn {
            padding-top: 18px;
            height: 60px;
            width: 100%;
            background-color: $purple-alt;
        }
	}
</style>
